import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
// import DialogTitle from '@material-ui/core/DialogTitle';
import InsiderAttackOptionsDataTable from "../requestedAttacks/InsiderAttackOptionsDataTable";
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import {Tooltip, withStyles} from "@material-ui/core";
import BBIconAdd from "../../../assets/bbCustomIcons/BBIconAdd";
import BBIconRocketSharpAdd from "../../../assets/bbCustomIcons/BBIconRocketSharpAdd";

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const FormDialog = (props) => {

    const {iconOnly = false, iconSize = null} = props;

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const DialogTitle = withStyles(styles)((props) => {
        const { children, classes, onClose, ...other } = props;
        return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });

    return (
        <div>
            <Tooltip title={"Order a new Attack on Demand or Internal Assessment"}>
                <Button
                    variant="outlined"
                    color="default"
                    onClick={handleClickOpen}
                    className={"text-electric-blue"}
                >
                    {iconOnly
                        ? <BBIconRocketSharpAdd style={{fontSize: "70px"}}/>
                        : <><BBIconAdd className={"mr-2"}/>New Insider Attack</>
                    }

                </Button>
            </Tooltip>

            <Dialog
                fullWidth={true}
                maxWidth={"xl"}
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    New Insider Attack
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Use the action buttons to order a new Insider Attack.  There are two types of attacks. <strong>Attack on Demand</strong> is a single attack against a single host of your choice. <strong>Internal Assessment</strong> is an objective-focused campaign of a limited duration with lateral movement.
                    </DialogContentText>
                    {/*<TextField*/}
                    {/*    autoFocus*/}
                    {/*    margin="dense"*/}
                    {/*    id="name"*/}
                    {/*    label="Email Address"*/}
                    {/*    type="email"*/}
                    {/*    fullWidth*/}
                    {/*/>*/}
                    <InsiderAttackOptionsDataTable />
                </DialogContent>
                <DialogActions>
                    {/*<Button onClick={handleClose} color="primary">*/}
                    {/*    Cancel*/}
                    {/*</Button>*/}
                    <Button onClick={handleClose} color="primary">
                        Done
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default FormDialog;
